import React, { useEffect, useState, useRef } from "react";
// import NavbarBrandBox from "./NavbarBrandBox";
import NotificationDropdown from "./NotificationDropdown";
import { Link, useLocation } from "react-router-dom";
import ProfileDropdownn from "./ProfileDropdownn";
import LogoutButton from "./LogoutButton";
import { CartItem } from "types";
import { Dropdown } from "react-bootstrap";
import { useCart } from "./CartContext";
import { showSuccess, showError } from "toast/toast";
import { License } from "types";
import logo from "../assets/images/RealEsy_V01.svg";
import CartDropdown from "./cart/CartDropdown";

import { getAuthCookie } from "../utils/authCookies";
const AgentHeader = () => {
  const userName = getAuthCookie("userName");
  const userType = getAuthCookie("userType");
  const userId = getAuthCookie("userId");
  const token = getAuthCookie("sessionToken");
  const cartId = localStorage.getItem("cart_id");
  const [loading, setLoading] = useState(true);
  // const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const cartDropdownRef = useRef<HTMLDivElement>(null);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { cartItems, fetchCart } = useCart();
  const [license, setLicense] = useState<License | null>(null);
  const [error, setError] = useState("");
  const location = useLocation();

  useEffect(() => {
    fetchCart();
  }, []);

  // Re-fetch cart on route change (ensures header updates after redirect)
  useEffect(() => {
    fetchCart();
  }, [location.pathname]);

  useEffect(() => {
    const fetchLicense = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/users/${userId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch license data");
        }

        const data = await response.json();
        // console.log("Fetched License Data:", data);
        if (data) {
          setLicense(data);
        }

      } catch (error) {
        console.error("Error fetching license data:", error);
        setError("Failed to fetch license data.");
      } finally {
        setLoading(false);
      }
    };

    if (!license) {
      fetchLicense();
    }
  }, [userId, license, token]);

  function toTitleCase(input: string): string {
    return input
      .split(" ") // Split the string into words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter
      .join(" "); // Join the words back into a string
  }

  // Fetch cart items on load
  //  useEffect(() => {
  //   const fetchCartItems = async () => {
  //     try {
  //       setLoading(true);
  //       const response = await fetch(`${process.env.REACT_APP_API_URL}/carts/${cartId}`, {
  //         method: "GET",
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //       });

  //       if (!response.ok) throw new Error("Failed to fetch cart data");

  //       const data = await response.json();
  //       setCartItems(data.cart_items || []);
  //     } catch (err) {
  //       console.error("Error fetching cart data:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   if (token && cartId) fetchCartItems();
  // }, [token, cartId]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        cartDropdownRef.current &&
        !cartDropdownRef.current.contains(event.target as Node)
      ) {
        setIsCartOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleRemoveProduct = async (productId: string, variantId: string) => {
    try {
      setLoading(true);
      const token = getAuthCookie("sessionToken");
      const cartId = localStorage.getItem("cart_id");

      if (!token || !cartId) {
        console.error("Missing token or cartId");
        setLoading(false);
        return;
      }
      // console.log("productId :", productId)
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/carts/${cartId}/products/${productId}/variants/${variantId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete product");
      }

      await fetchCart(); // Refresh the cart items
      showSuccess("Product removed successfully!");
    } catch (err) {
      showError("Failed to remove product");
    } finally {
      setLoading(false);
    }
  };

  // Close sidebar on ESC (mobile only)
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (window.innerWidth <= 767 && e.key === "Escape") {
        document.body.classList.remove("vertical-sidebar-enable", "sidebar-enable");
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  // Close sidebar when resizing to tablet/desktop
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 768) {
        document.body.classList.remove("vertical-sidebar-enable", "sidebar-enable");
      }
    };
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Close when clicking anywhere outside the sidebar (backup to overlay)
  useEffect(() => {
    const onDocMouseDown = (e: MouseEvent) => {
      if (window.innerWidth > 767) return;
      if (!document.body.classList.contains("vertical-sidebar-enable")) return;
      const target = e.target as Element;
      const insideSidebar = target.closest(".app-menu.navbar-menu");
      if (!insideSidebar) {
        document.body.classList.remove("vertical-sidebar-enable", "sidebar-enable");
      }
    };
    document.addEventListener("mousedown", onDocMouseDown);
    return () => document.removeEventListener("mousedown", onDocMouseDown);
  }, []);

  return (
    <header id="page-topbar">
      <div className="layout-width">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box horizontal-logo">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logo} alt="" height="17" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logo} alt="" height="17" />
                </span>
              </Link>
            </div>

            {/* ✅ Mobile-only hamburger (≤767px) */}
            <button
              type="button"
              className="btn btn-sm px-3 fs-16 header-item d-inline-flex d-md-none material-shadow-none"
              aria-label="Open sidebar"
              onClick={() => document.body.classList.add("vertical-sidebar-enable")}
            >
              <i className="ri-menu-2-line"></i>
            </button>
          </div>

          <div className="d-flex align-items-center">
            <CartDropdown base="agent" />
            {/* assets/images/users/avatar-1.jpg */}
            {/* <NotificationDropdown /> */}
            <ProfileDropdownn name={userName || "Guest"} role={userType || "Agent"} imageUrl={license?.profilePic || ""} login= {"agent"} token={token ||""}/>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AgentHeader;